import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FocusRingVariants, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 40px 0;

	${minWidth('tablet')} {
		padding: 64px 0;
	}
`;

export const Grid = styled(GridWrapper)`
	grid-template-columns: 1fr;
`;

export const ContentWrapper = styled.div`
	margin: 0 auto;
	max-width: 760px;
	text-align: center;
`;

export const Text = styled.h2`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 52px;
`;

export const Cta = styled(Button).attrs({
	focusRingVariant: FocusRingVariants.Dark,
})`
	margin-bottom: 52px;
	min-width: 290px;
`;

export const Disclaimer = styled.p`
	color: ${palette('gray4')};
	font-size: 13.5px;
	${fontWeight(FontWeights.Medium)};
`;
